import InputBase from "@mui/material/InputBase";
import { styled, alpha } from "@mui/material/styles";

export const checkboxStyle = {
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#1D4ED8',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#1D4ED8',
  },
  width: '200px',
  height:"2.75rem",
  'border-radius': '0.5rem',
  '.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input': {
    padding: '0.625rem 0.825rem',
  }
}
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 100,
    },
  },
};



export const unselectedStyle = {
  minWidth: '2rem',
  maxWidth: '2rem',
  height: '2rem',
}

export const selectedStyle = {
  color: "#367C39",
  borderColor: "#367C39",
  background: "#F1F8F5",
  minWidth: '2rem',
  maxWidth: '2rem',
  height: '2rem'
}


export const TableStyle = {
  py: 0,
  width: '100%',
  borderRadius: '2',
  border: '1px solid',
  borderColor: 'divider',
  backgroundColor: '#F5F7F8',
};



export const activeStyle = {
  color: 'white',
  background: '#0066DC',
  borderColor: '#0066DC',
};

export const inactiveStyle = {
  backgroundColor: '#FFFFFF',
  color: '#252D38',
  borderColor: '#A4B0C0',
};

export const disabledStyle = {
  backgroundColor: '#F5F7F8',
  color: '#A4B0C0',
  borderColor: '#A4B0C0',
};


export const SelectInputCheckBoxStyle = {
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#1D4ED8',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#1D4ED8',
  },
  width: '200px',
  height: '36px',  // Ensure height matches your button
  borderRadius: '0.5rem',
  padding: '0.375rem 0.825rem',  // Match button padding
  '.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input': {
    padding: '0.375rem 0.825rem',  // Match button padding
  }
}


export const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});


export const customStylesMultiSelect = {
  container: (provided) => ({
    ...provided,
    width: '31.6rem',
    backgroundColor: 'transparent',
  }),
  control: (provided) => ({
    ...provided,
    minHeight: '2.75rem',
    borderRadius: '0.5rem',
    backgroundColor: 'transparent',
  }),
  valueContainer: (provided) => ({
    ...provided,
    minHeight: '2.75rem',
    backgroundColor: 'transparent',
  }),
};


export const Search = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  height: "60%",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

export const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "relative",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#ffffff",
  right: 0,
  borderTopRightRadius: "2px",
  borderBottomRightRadius: "2px",
}));

export const checkBoxCustomStyle = {
  color: "inherit",
    fontSize: '24px', 
    '&.Mui-checked': {
      color: '#1778F2', 
    },
    '&.Mui-disabled': {
      color: '#70829B', 
    },
}

export const checkBoxWithBlueBorder = {
  color: "#1778F2",
    fontSize: '24px',
    '&.Mui-checked': {
      color: '#1778F2', 
    },
    '&.Mui-disabled': {
      color: '#70829B', 
    },
}

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  backgroundColor: "#ffffff",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em)`,
    paddingRight: `calc(1em + ${theme.spacing(5)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "50ch",
      cursor: "pointer",
      backgroundColor: "#ffffff",
    },
  },
}));

